import { Stack } from "@mantine/core"

import { CommunicationStudioClasses } from "@tfg/types/constants/communication-studio.constant"
import { imageAlignCSSVariable } from "@tfg/types/schemas/communication-studio/cssVariables"

import { DesignStudioParametersToolkit } from "../utils/designStudioParametersToolkit"

export type ProductImageComponentProps = {
  image: string | null
}
export const ProductImageComponent = ({
  image,
}: ProductImageComponentProps) => {
  if (!image) {
    return null
  }
  return (
    <Stack
      align={DesignStudioParametersToolkit.getCssVariableLiteralName(
        imageAlignCSSVariable
      )}
      maw="100vw"
    >
      <img
        className={CommunicationStudioClasses.PRODUCT_IMAGE}
        src={image}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        alt="product-image"
      />
    </Stack>
  )
}
